/*
 * Created Date: Wed, 17th Feb 2021, 16:52:22 pm
 * Author: Kristyna Fojtikova
 * Email: kristyna.fojtikova@thedistance.co.uk
 * Copyright (c) 2021 The Distance
 */

import * as React from 'react';
import { AppBar } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import PASMALogo from '../../assets/PASMA_LOGO_white.png';

const useStyles = makeStyles({
  title: {
    flex: 1,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
});

const CustomAppBar = props => {
  const classes = useStyles();
  return (
    <AppBar {...props}>
      <img alt="logo" src={PASMALogo} style={{ marginRight: 15, height: 30 }} />
      <Typography
        variant="h6"
        color="inherit"
        className={classes.title}
        id="react-admin-title"
      />
    </AppBar>
  );
};

export default CustomAppBar;
